import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet } from 'react-native';
import { Spacing } from '../../styles';
import { Colors } from '../../themes';
import { CustomAlert } from '../customAlert';
import { SaveButton } from '../navigation';
import { SaveFormTopProps } from './formTypes';

export const SaveFormTop = (props: SaveFormTopProps) => {
  const TopComponentBar = props.topBar;
  const { t } = useTranslation();
  const canSave = useMemo(() => {
    const isDirty = props.isDirty === undefined ? true : props.isDirty;
    const isValid = props.isValid === undefined ? true : props.isValid;
    return isDirty && isValid;
  }, [props.isDirty, props.isValid]);
  const [alertVisible, setAlertVisible] = useState(false);
  const showAlert = () => setAlertVisible(true);
  const hideAlert = () => setAlertVisible(false);
  
  const handleConfirmedCancel = () => {
    hideAlert();

    if (props.onCancel) {
      props.onCancel();
    }
  };
  const rightButton = (
    <SaveButton
      onPress={props.onSubmit}
      disabled={!canSave}
      isLoading={false}
      activeTextColor={canSave ? Colors.white : undefined}
      label={props.saveLabel ?? t('topNav.save')}
      style={[
        styles.baseButton,
        canSave ? styles.addButtonEnabled : styles.addButtonDisabled,
      ]}
    />
  );

  return (
    <>
      <TopComponentBar
        title={props.title}
        showSave={!props.hideSaveButton}
        onRightPress={props.onSubmit}
        rightPressDisabled={!canSave}
        confirmBack={props.isDirty && !alertVisible}
        showAlert={showAlert}
        additionalHeaderBlock={props.additionalHeaderBlock}
        backButtonLabel={props.backButtonLabel}
        saveLabel={props.saveLabel}
        right={props.hideSaveButton ? undefined : rightButton}
        onCancel={props.onCancel}
      />
      <CustomAlert
        visible={alertVisible}
        hideAlert={hideAlert}
        action={handleConfirmedCancel}
        title={t('topNav.customAlert.exit')}
        primaryButtonLabel={t('topNav.customAlert.yes')}
        secondaryButtonLabel={t('topNav.customAlert.cancel')}
        tertiaryButtonLabel={props.showSaveDraftButton ? t('topNav.customAlert.saveProgress') : undefined}
        tertiaryAction={props.onSaveDraft}
      />
      {props.children}
    </>
  );
};

const styles = StyleSheet.create({
  baseButton: {
    minWidth: 60,
    height: 28,
    maxWidth: 86,
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    borderRadius: 8,
    marginRight: Spacing.baseMargin.base,
    paddingHorizontal: 8,
  },
  addButtonDisabled: {
    backgroundColor: Colors.grayDivider,
  },
  addButtonEnabled: {
    backgroundColor: Colors.primary,
  },
});
